import { parseDSL } from './parser';
import type { IRPattern } from '../types/ir';
import type { Pattern } from '../types/state';
import type { Session } from '../types/session';

/**
 * Returns the IRPattern the engine should use for this session: the
 * recompiled DSL on the session if present (JS-authored pattern with
 * non-default params), else the pattern's authored structure.
 */
export function resolveSessionPattern(pattern: Pattern, session: Session): IRPattern | undefined {
  if (session.compiledDsl) {
    try {
      return parseDSL(session.compiledDsl);
    } catch (err) {
      console.warn('Failed to parse session.compiledDsl; falling back to pattern.structure', err);
    }
  }
  return pattern.structure;
}
